import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/whatsapp";

export default function WhatsAppButton({ content = {} }) {
  return (
    <motion.a
      href={whatsappLink(content, "Olá! Vim pelo site do EKKO e gostava de mais informações.")}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      aria-label="Falar com o EKKO Fitness Center no WhatsApp"
      data-testid="whatsapp-button"
    >
      <MessageCircle size={28} className="text-white" />
    </motion.a>
  );
}
